import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const AdButler = ({ adbutlerInfo, isSignedIn, display = true }) => {
  const { id, zone, size, keywords, domain, place } = adbutlerInfo;
  const heightSize = size?.[0] || 0;

  const userStatus = isSignedIn ? 'signed-in' : 'signed-out';

  useEffect(() => {
    if (window.AdButler) {
      window.AdButler.ads.push({
        handler: (opt) => {
          window.AdButler.register(id, zone, size, `placement_${zone}_${opt.place}`, opt);
        },
        opt: {
          place: place,
          keywords: [...keywords, userStatus].join(','),
          domain: domain,
          click: 'CLICK_MACRO_PLACEHOLDER',
        },
      });
    }
  }, []);

  const styles = {
    display: display ? 'block' : 'none',
    minHeight: `${heightSize + Math.round(heightSize * 0.1)}px`,
  };

  return (
    <div
      className='adbutler'
      data-testid='adbutler'
      style={styles}
      aria-hidden={`${display ? 'false' : 'true'}`}
    >
      <div id={`placement_${zone}_${place}`}></div>
    </div>
  );
};

AdButler.propTypes = {
  adbutlerInfo: PropTypes.shape({
    id: PropTypes.number.isRequired,
    size: PropTypes.arrayOf(PropTypes.number).isRequired,
    zone: PropTypes.number.isRequired,
    domain: PropTypes.string.isRequired,
    keywords: PropTypes.arrayOf(PropTypes.string).isRequired,
    place: PropTypes.number.isRequired,
  }),
  isSignedIn: PropTypes.bool.isRequired,
  display: PropTypes.bool,
};

export default AdButler;
